<template>
    <div>
        <div class="form-group" :class="{'has-error': errors.has('actionItem')}">
            <label for="actionItem" class="col-sm-2 control-label">Follow up on:</label>
            <div class="col-sm-8">
                <input v-validate.disable="'required'" data-vv-as="follow up on" type="text" 
                       class="form-control" id="actionItem" name="actionItem" v-model="timeEntry.actionItem" 
                       placeholder="What is to be done?" maxlength="50" 
                       :disabled="timeEntry.isAuditEdit" />
                <p class="text-danger" v-if="errors.has('actionItem')">{{ errors.first('actionItem') }}</p>
            </div>
        </div>

        <div class="form-group" :class="{'has-error': errors.has('followupAdjuster')}">
            <label for="followupAdjuster" class="col-sm-2 control-label">Assigned to:</label>
            <div class="col-sm-5 col-md-4 col-lg-3">
                <user-picker v-validate.disable="'required'" data-vv-as="assigned to" name="followupAdjuster" v-model="timeEntry.followupAdjuster" :disabled="timeEntry.isAuditEdit" :is-outlook="isOutlook">
                </user-picker>
                <p class="text-danger" v-if="errors.has('followupAdjuster')">{{ errors.first('followupAdjuster') }}</p>
            </div>
        </div>

        <div class="form-group" :class="{'has-error': errors.has('followupDate')}">
            <label for="followupDate" class="col-sm-2 control-label">Follow up by:</label>
            <div class="col-sm-4 col-md-3 col-lg-2">
                <div style="max-width:150px">
                    <datepicker v-validate.disable="'required'" data-vv-as="follow up by" name="followupDate" v-model="timeEntry.followupDate" :calendar-button="true" calendar-button-icon="fa fa-calendar"
                                :clear-button="false" clear-button-icon="fa fa-times" :bootstrap-styling="true"
                                format="yyyy MMM dd" :typeable="isTypeable" :disabled="timeEntry.isAuditEdit"></datepicker>
                </div>
                <p class="text-danger" v-if="errors.has('followupDate')">{{ errors.first('followupDate') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import Datepicker from 'vuejs-datepicker'
    import UserPicker from "./user-picker";

    Vue.component("datepicker", Datepicker);
    Vue.component("user-picker", UserPicker);

    export default {
        inject: ['$validator'],
        data: function () {
            return {
                timeEntry: this.$store.state.timeEntry,
            };
        },
        props: {
            isOutlook: Boolean
        },
        computed: {
            isTypeable() {
                // there is a bug in Safari with the datepicker
                // https://stackoverflow.com/a/23522755/2616170
                !/^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            }
        },
        components: { UserPicker },
    };
</script>